ApiError = require 'network/api-error'
Auth = require 'db/auth'
Payloads = require 'network/payloads'
getExperiment = require 'lib/experiments/simple-test'
EnterpriseAdminDashboardView = undefined
queueRequire -> EnterpriseAdminDashboardView = require 'views/enterprise/enterprise-admin-dashboard-view'
Enterprise = undefined
queueRequire -> Enterprise = require 'models/enterprise'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
log = require 'debug/log'
Promise = require 'bluebird'
$ = require 'jquery'
ldclient = require 'lib/ldclient'

module.exports =
  routes: [
    ['e/:name/admin', 'enterpriseAdminDashboardView']
    ['e/:name/admin/*tab', 'enterpriseDashTab']
  ]

  displayEnterprisePage: (settings) ->
    { enterpriseName, viewClass, tab } = settings

    log('controller', ['enterprise'])

    Promise.using @getSpinner(), =>
      enterprise = ModelCache.findOne('Enterprise', 'name', enterpriseName)
      enterpriseIdOrName = enterprise?.id || enterpriseName

      Enterprise.load enterpriseIdOrName, Payloads.enterprise, ModelCache
      .then (enterprise) =>
        if Auth.me() && Auth.isLoggedIn() && !Auth.confirmed() &&
            getExperiment('confirmDuringSignup').get('enabled')
          return @navigate '/confirm-email', { trigger: true }
        # We need to check this here rather than at the beginning of the method
        # cause sometimes Auth.me() doesn't yet exist there, but it always
        # exists here.
        unless Auth.me().get('confirmed')
          @displayErrorPage
            errorType: 'unconfirmedEnterpriseNotFound'
            email: Auth.me().get('email')
          return

        if tab == 'settings' && !(ldclient.variation('enterprise.widePerms', false))
          @displayErrorPage()
          return

        if !enterprise.isRealEnterprise()
          @displayErrorPage()
          return

        @clearPreviousView()
        @setViewType(enterprise)
        @showHeader()
        $('#classic-body').addClass('body-tabbed-page')

        options = { modelCache: ModelCache, initialTab: tab }
        enterpriseView = @topLevelView(viewClass, enterprise, options)
        $('#content').html(enterpriseView.render().el)

        title = enterprise.get('displayName')

        @setLocation
          title: title
          location: settings.getLocation.call(@, enterprise.get('name'), tab)

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  enterpriseAdminDashboardView: (enterpriseName) ->
    @displayEnterprisePage
      enterpriseName: enterpriseName
      viewClass: EnterpriseAdminDashboardView
      getLocation: @getEnterpriseAdminDashboardUrl
    .done()

  enterpriseDashTab: (enterpriseName, tab) ->
    allowedTabs = ['members', 'teams', 'teams/pending', 'settings']

    if tab not in allowedTabs
      @displayErrorPage()
      return

    @displayEnterprisePage
      enterpriseName: enterpriseName
      viewClass: EnterpriseAdminDashboardView
      getLocation: @getEnterpriseAdminDashboardUrl
      tab: tab
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/enterprise-routes.coffee